export default __webpack_public_path__ + "static/media/background.2d0ea620.png";